<script>
  let providerSelect;
  let planName;
  let planNameElem;
  let hidePlanNameInput = true;
  let isDisabled = true;
  let hasError = true;
  function providerChange(e) {
    if (providerSelect === "medicare-advantage") {
      hidePlanNameInput = false;
    } else {
      hidePlanNameInput = true;
    }
    // console.log("e", e);
    validateField(e);
  }

  let message;
  async function handleSubmit(e) {
    const response = await fetch(
      // "https://secureweb_dev.ccsmed.com/cgm_qualification/mailer.php",
      "https://secureweb.ccsmed.com/cgm_qualification/mailer.php",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          firstName: e.target.firstName.value,
          lastName: e.target.lastName.value,
          phoneNumber: e.target.phoneNumber.value,
          emailAddress: e.target.emailAddress.value,
          stateOfResidence: e.target.stateOfResidence.value,
          insuranceProvider: e.target.insuranceProvider.value,
          planName: e.target.planName.value
        })
      }
    );
    const r = await response;
    // console.log("r", r);

    if (r.status === 200) {
      // console.log("r in if", r);
      let json = await r.json();
      // console.log("json", json);
      message = json.message;
    }
  }

  let fields = [];
  function validateField(e) {
    if (e.target.required && e.target.value === "") {
      if (fields.includes(e.target.name)) {
        fields = fields.filter(f => f !== e.target.name);
      }
      hasError = true;
    } else {
      if (!fields.includes(e.target.name)) {
        fields.push(e.target.name);
      }
    }
    isDisabled = fields.length !== 5 ? true : false;
  }

  function gaCount(event) {
    console.log("1");
    gtag("send", {
      hitType: "event",
      eventCategory: "buttonClick",
      eventAction: "sentEmail",
      eventLabel: "CGMinfoCaptured"
    });
  }
</script>

<style>
  .container {
    margin: 1rem auto;
    max-width: 32rem;
    padding: 1rem;
  }

  .block {
    display: block;
  }
  .hidden {
    display: none;
  }

  .mt {
    margin-top: 1.5rem;
  }
  .mt-2 {
    margin-top: 0.75rem;
  }
  .italics {
    font-style: italic;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }

  .disclaimer {
    color: #ddd;
  }

  h1 {
    font-size: 2.25rem;
  }

  p {
    font-size: 1.25rem;
  }

  input,
  select {
    border-radius: 0.25rem;
    padding: 0.5rem;
    width: 100%;
  }
  select {
    font-size: 0.75rem;
  }

  button {
    background-color: #dedede;
    background-color: rgb(21, 156, 107);
    border-radius: 0.25rem;
    color: #fff;
    font-size: 1.25rem;
    font-weight: bold;
    padding: 1rem 0.5rem;
    text-align: center;
    width: 12rem;
  }

  header {
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    padding-bottom: 0.75rem;
  }

  header a {
    color: #fff;
    font-size: 1.25rem;
    margin-left: auto;
    margin-right: 2rem;
    padding: 0.25rem;
  }
  .logo {
    margin: 0 auto 0 2rem;
    width: 125px;
  }
  svg {
    color: #fff;
    fill: currentColor;
  }

  .disabled {
    cursor: not-allowed;
    opacity: 0.75;
  }

  .zip {
    float: left;
    height: 0;
    margin-left: -99999rem;
    position: relative;
    width: 0;
  }
</style>

<header>
  <div class="logo">
    <a href="https://www.ccsmed.com/">
      <div class="sr-only">CCS Medical</div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        x="0"
        y="0"
        viewBox="0 0 957.9 586.8"
        xml:space="preserve">
        <title>CCS Medical Logo</title>
        <desc>CCS Medical Logo</desc>
        <path
          d="M182.3 5.9C121.2 14.6 59.4 33.8 0 58.8c61.7 28.7 121.9 54.5 180.4
          82.1 59.4-26.5 118.7-52.5 179.5-76C301 40.9 240.2 23.6 182.3 5.9M379.5
          0c-28.6 8.6-58.1 16.4-87.7 25.2 29.1 8.9 58.3 18.9 87.2 30.2 29.7-11.6
          59.6-22.7 89-35.1C438.6 11.3 409 4.5 379.5 0M450.7 44c-38.2 15.4-76.6
          30-114.5 45.6 37 15.9 73.4 33 110.1 50.1 37.4-16.6 75.6-32.9
          114.7-49.9C525 72.9 488.1 57 450.7 44" />
        <path
          d="M296.3 139.5c21.9 0 41.4 2.8 58.6 8.3 17.2 5.5 25.7 11.8 25.7
          18.8l-0.4 11.4 2.7 29c0 13.5-3.1 20.5-9.3 21 -2.9
          0.3-6.5-3.5-10.9-11.3 -8.1-14.6-21.8-27.2-40.9-37.9
          -19.2-10.7-37.8-16-55.8-16 -24.9 0-45.2 11.4-60.9 34.1 -15.7 22.7-23.6
          52-23.6 87.8 0 42.4 12.1 78.3 36.4 107.6 24.2 29.3 53.9 44 88.9 44
          28.2 0 55.8-11.6 83-34.7 3.4-2.8 6.5-4.3 9.4-4.6 3.9-0.5 5.9 1.3 5.9
          5.3 0 5.6-6.1 13.8-18.3 24.7 -31.5 28.3-69.4 42.5-113.7 42.5 -40.7
          0-74.7-14.8-102.1-44.4 -27.3-29.6-41-66.2-41-109.9 0-48.8 16.2-90.3
          48.6-124.4C211.1 156.6 250.3 139.5 296.3 139.5zM608 139.5c21.9 0 41.4
          2.8 58.6 8.3 17.2 5.5 25.8 11.8 25.8 18.8L692 178l2.7 29c0 13.5-3.1
          20.5-9.3 21 -2.8 0.3-6.5-3.5-10.9-11.3 -8.1-14.6-21.8-27.2-40.9-37.9
          -19.2-10.7-37.8-16-55.8-16 -24.9 0-45.2 11.4-60.9 34.1 -15.7 22.7-23.6
          52-23.6 87.8 0 42.4 12.1 78.3 36.4 107.6 24.2 29.3 53.9 44 88.9 44
          28.2 0 55.9-11.6 83-34.7 3.4-2.8 6.5-4.3 9.4-4.6 3.9-0.5 5.9 1.3 5.9
          5.3 0 5.6-6.1 13.8-18.3 24.7 -31.5 28.3-69.4 42.5-113.7 42.5 -40.7
          0-74.7-14.8-102.1-44.4 -27.3-29.6-41-66.2-41-109.9 0-48.8 16.2-90.3
          48.6-124.4C522.8 156.6 562 139.5 608 139.5zM859 139.5c20.1 0 37.4 2.6
          51.9 7.9l16.8 5.6c6.9 2.5 10.3 6.4 10.3 11.6v6.1c0 3.6 0.3 7.1 0.8
          10.7l1.5 14.9c0.8 5.3 1.1 10.2 1.1 14.5 0 9.9-2.9 15-8.6 15.3 -3.1
          0.3-6-3.1-8.6-9.9 -14-38.7-40.2-58-78.6-58 -15.3 0-27.8 4.3-37.6 13
          -9.8 8.7-14.7 19.7-14.7 32.9 0 14 5.3 25.4 15.8 34.1 10.5 8.7 31.9
          19.3 63.9 31.8 31.8 12.4 53.8 25.6 66.2 39.4 12.3 13.8 18.5 32.4 18.5
          55.8 0 28.7-10.6 53.2-31.9 73.7 -21.2 20.4-46.6 30.7-76.1 30.7 -21.1
          0-44-6-68.7-17.9
          -5.9-2.8-9.5-4.2-11.1-4.2l-9.9-1.1c-5.9-0.5-9-3.7-9.5-9.5l-0.4-16.3
          -1.1-48.6 0.8-11.4c1-6.8 3.9-10.4 8.6-10.6 4.7-0.2 7.8 3.6 9.3 11.4
          5.3 28 15.7 49.9 31.1 65.6 15.4 15.8 33.9 23.6 55.5 23.6 18.6 0
          33.8-5.5 45.6-16.5 11.8-11 17.7-25 17.7-42.1
          0-26-14.4-45.4-43.1-58.2l-33.6-14.9c-30.5-13.2-52.1-26.8-64.9-40.9
          -12.7-14.1-19.1-31.3-19.1-51.6 0-24.4 9.8-44.9 29.4-61.7C806.2 147.9
          830.3 139.5 859 139.5z" />
        <path
          d="M239.1 585.2h-11.3V509l-25.3 76.2h-10.7L166.4
          509v76.2h-11.2v-89.7H173l24 74.7 24.2-74.7h17.8V585.2zM367.3
          585.2h-66.6v-89.7h64.6v10.6h-52.7v27.4h49.3V544h-49.3v30.6h54.7V585.2zM499.3
          539.9c0 30.2-15.2 45.3-45.5 45.3h-28.3v-89.7h28.3C484.1 495.5 499.3
          510.3 499.3 539.9zM487.2 539.9c0-5.3-0.5-10-1.6-14.1
          -1-4.2-2.8-7.7-5.3-10.6 -2.5-2.9-5.9-5.1-10.3-6.7
          -4.3-1.5-9.8-2.3-16.3-2.3h-16.3v68.5h16.3c6.5 0 11.9-0.8 16.2-2.4
          4.3-1.6 7.7-3.9 10.3-6.8 2.5-3 4.4-6.6 5.4-10.9C486.7 550.2 487.2
          545.3 487.2 539.9zM570.4 585.2h-11.9v-89.7h11.9V585.2zM706.9
          522.7h-12c-0.2-2.9-0.9-5.4-2.2-7.7 -1.3-2.3-3-4.3-5.1-5.9
          -2.1-1.6-4.6-2.9-7.5-3.7 -2.9-0.9-5.9-1.3-9.2-1.3 -4.5 0-8.6 0.8-12.2
          2.4 -3.6 1.6-6.7 3.9-9.3 7 -2.6 3.1-4.5 6.9-5.9 11.4 -1.4 4.5-2.1
          9.7-2.1 15.5 0 5.8 0.7 11 2.1 15.5 1.4 4.5 3.3 8.3 5.9 11.4 2.5 3.1
          5.6 5.5 9.2 7.1 3.6 1.6 7.6 2.4 12.1 2.4 7 0 12.7-1.7 17-5.1 4.3-3.4
          6.8-8.4 7.3-14.8h12c-0.4 4.8-1.6 9-3.6 12.7 -1.9 3.7-4.5 6.8-7.6 9.4
          -3.2 2.6-6.9 4.5-11.1 5.9 -4.2 1.4-8.8 2-13.8 2 -6.4
          0-12.1-1.1-17.2-3.3 -5.1-2.2-9.4-5.3-13-9.3 -3.6-4-6.4-8.9-8.3-14.6
          -1.9-5.7-2.9-12.2-2.9-19.2s1-13.4 3-19.2c2-5.7 4.7-10.6 8.3-14.7 3.6-4
          7.9-7.1 13-9.3 5.1-2.2 10.8-3.3 17.1-3.3 4.7 0 9.2 0.7 13.4 2 4.2 1.4
          7.9 3.3 11.1 5.8 3.2 2.5 5.9 5.6 7.9 9.1C705.3 514.5 706.5 518.4 706.9
          522.7zM838.3 585.2H825l-10.4-27.3h-37.5l-9.9
          27.3h-12.4l34.2-89.7h12.7L838.3 585.2zM811.2 548.4l-15.9-41.5 -15
          41.5H811.2zM945 585.2h-55.3v-89.7h11.9v79.1H945V585.2z" />
        <path
          d="M937 495.5c4.4 0 8 3.6 8 8.1 0 4.5-3.5 8.1-8 8.1 -4.4
          0-7.9-3.6-7.9-8.1C929.1 499.2 932.7 495.5 937 495.5zM937 510c3.4 0
          6-2.8 6-6.3 0-3.5-2.6-6.3-6-6.3 -3.3 0-5.9 2.8-5.9 6.3C931.1 507.2
          933.7 510 937 510zM934.2 499.6h3.4c1.6 0 2.7 1 2.7 2.6 0 1.3-0.9
          1.9-1.4 2.1v0c0 0 0.1 0.1 0.3 0.5l1.5
          2.9h-2.1l-1.4-3h-1.1v3h-1.9V499.6zM937.2 503.3c0.7 0 1.2-0.5 1.2-1.2
          0-0.8-0.4-1.2-1.1-1.2h-1.1v2.4H937.2z" />
      </svg>
    </a>
  </div>

  <a href="https://www.ccsmed.com/">&larr; Back to Main Site</a>
</header>

<div class="container">
  {#if message}
    {@html message}
  {:else}
    <h1 class="">Eliminate painful fingersticks!</h1>

    <p class="mt">
      Medicare now covers Continuous Glucose Monitoring Systems for qualified
      patients. See if you qualify!
    </p>

    <form
      action=""
      method="post"
      id="cgm-lead-form"
      on:submit|preventDefault={handleSubmit}>
      <fieldset>
        <legend class="sr-only">Patient Information</legend>
        <label for="firstName">
          <span class="block mt">First Name*:</span>
          <input
            on:keyup={validateField}
            on:blur={validateField}
            type="text"
            placeholder="First Name"
            name="firstName"
            id="firstName"
            class="first-name mt-2"
            required />
          <div class="hidden required-text">This field is required</div>
        </label>

        <label for="lastName">
          <span class="block mt">Last Name*:</span>
          <input
            on:keyup={validateField}
            on:blur={validateField}
            type="text"
            placeholder="Last Name"
            name="lastName"
            id="lastName"
            class="last-name mt-2"
            required />
          <div class="hidden required-text">This field is required</div>
        </label>

        <label for="phoneNumber">
          <span class="block mt">Daytime Phone Number*:</span>
          <input
            on:keyup={validateField}
            on:blur={validateField}
            type="text"
            placeholder="Daytime Phone Number"
            name="phoneNumber"
            id="phoneNumber"
            class="phone-number mt-2"
            required />
          <div class="hidden required-text">This field is required</div>
        </label>

        <label for="emailAddress">
          <span class="block mt">Email*:</span>
          <input
            on:keyup={validateField}
            on:blur={validateField}
            type="email"
            placeholder="youremail@example.com"
            name="emailAddress"
            id="emailAddress"
            class="email-address mt-2"
            required />
          <div class="hidden required-text">This field is required</div>
        </label>

        <label for="stateOfResidence">
          <span class="block mt">State of Residence:</span>
          <select name="stateOfResidence" id="stateOfResidence">
            <option value="AL">Alabama</option>
            <option value="AK">Alaska</option>
            <option value="AZ">Arizona</option>
            <option value="AR">Arkansas</option>
            <option value="CA">California</option>
            <option value="CO">Colorado</option>
            <option value="CT">Connecticut</option>
            <option value="DE">Delaware</option>
            <option value="DC">District Of Columbia</option>
            <option value="FL">Florida</option>
            <option value="GA">Georgia</option>
            <option value="HI">Hawaii</option>
            <option value="ID">Idaho</option>
            <option value="IL">Illinois</option>
            <option value="IN">Indiana</option>
            <option value="IA">Iowa</option>
            <option value="KS">Kansas</option>
            <option value="KY">Kentucky</option>
            <option value="LA">Louisiana</option>
            <option value="ME">Maine</option>
            <option value="MD">Maryland</option>
            <option value="MA">Massachusetts</option>
            <option value="MI">Michigan</option>
            <option value="MN">Minnesota</option>
            <option value="MS">Mississippi</option>
            <option value="MO">Missouri</option>
            <option value="MT">Montana</option>
            <option value="NE">Nebraska</option>
            <option value="NV">Nevada</option>
            <option value="NH">New Hampshire</option>
            <option value="NJ">New Jersey</option>
            <option value="NM">New Mexico</option>
            <option value="NY">New York</option>
            <option value="NC">North Carolina</option>
            <option value="ND">North Dakota</option>
            <option value="OH">Ohio</option>
            <option value="OK">Oklahoma</option>
            <option value="OR">Oregon</option>
            <option value="PA">Pennsylvania</option>
            <option value="RI">Rhode Island</option>
            <option value="SC">South Carolina</option>
            <option value="SD">South Dakota</option>
            <option value="TN">Tennessee</option>
            <option value="TX">Texas</option>
            <option value="UT">Utah</option>
            <option value="VT">Vermont</option>
            <option value="VA">Virginia</option>
            <option value="WA">Washington</option>
            <option value="WV">West Virginia</option>
            <option value="WI">Wisconsin</option>
            <option value="WY">Wyoming</option>
          </select>
        </label>

        <label for="zipCode" class="zip">
          <span class="block mt">Zipcode:</span>
          <input
            tabindex="-1"
            on:keyup={validateField}
            on:blur={validateField}
            type="text"
            placeholder="zip code"
            name="zipCode"
            id="zipCode"
            class="phone-number mt-2" />
        </label>

        <label for="insuranceProvider">
          <span class="block mt">Insurance Provider*</span>
          <select
            bind:value={providerSelect}
            on:change={providerChange}
            id="insuranceProvider"
            name="insuranceProvider"
            class="block mt-2 insurance-provider"
            required>
            <optgroup label="Insurance Provider">
              <option value="">- Select one -</option>
              <option value="medicare">Medicare</option>
              <option value="medicare-advantage">Medicare Advantage</option>
            </optgroup>
          </select>
          <div class="hidden required-text">This field is required</div>
        </label>

        <label
          for="planName"
          bind:this={planNameElem}
          class="plan-name"
          class:hidden={hidePlanNameInput}>
          <span class="block mt">Name of Plan:</span>
          <input
            bind:value={planName}
            type="text"
            name="planName"
            id="planName" />
        </label>
      </fieldset>

      <p class="mt">
        <small>* Indicates required field</small>
      </p>

      <p class="mt italics disclaimer">
        A CCS Medical Patient Support Representative will contact you soon about
        a Medicare-covered CGM System.
      </p>

      <button
        type="submit"
        class="mt submit-button"
        class:disabled={isDisabled}
        disabled={isDisabled}>
        See if I qualify!
      </button>
    </form>
  {/if}
</div>
